import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'
import ScrollMixin from '@/mixins/Scroll.js'

import AppPicture from '@/components/app-picture'
import AppParallax from '@/components/app-parallax'
import AppContent from '@/components/app-content'
import AppVisualListWidget from '@/components/app-visual-list-widget'
import AppContentGlobe from '@/components/app-content-globe'

export default
{
    name: 'app-page-about',

    mixins:
    [
        EventHubMixin,
        APIMixin,
        ScrollMixin
    ],

    components:
    {
        AppPicture,
        AppContent,
        AppVisualListWidget,
        AppContentGlobe,
        AppParallax
    },

    filters:
    {
        slugify(_value)
        {
            const result = _value.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '')

            return result
        }
    },

    data()
    {
        return {
            content: null
        }
    },

    created()
    {
        this.fetch('pages', { slug: 'about', per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || data.length < 1)
            {
                this.$router.push({ name: '404' })
                return
            }

            this.content = data[0]

            // SEO
            document.title = this.content.acf.seo_title ? this.content.acf.seo_title : this.content.acf.title.replace(/<br ?\/?>/gi, '')
            if(this.content.acf.seo_description)
            {
                document.querySelector('meta[name=description]').content = this.content.acf.seo_description
            }

            // Papillon
            this.$nextTick(() =>
            {
                window.dispatchEvent(new Event('papillon'))
            })

        }, this.$root.isFirstPage())
    },

    mounted()
    {
        this.$eventHub.$emit('headerLogo.setState', { state: 'logo' })

        window.requestAnimationFrame(() =>
        {
            this.$eventHub.$emit('line.setElement', this.$refs.lineMark, true)
        })
    },

    methods:
    {
        onBackTopClick()
        {
            this.animateTo(0, 1)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-about/script.js